import { DeviceColumnTypes } from "pages/Devices/devices.config";
import { COLUMN_TYPE } from "utils/constants";
import { formatPhoneNumber } from "utils/util-functions";

export interface DeviceDataTypes {
  devicePool: string;
  imei: string;
  orgGroup: string;
  serialNumber: string;
  userName: string;
}

export const DEVICE_LOOKUP_COLUMNS: DeviceColumnTypes[] = [
  {
    id: "serialNumber",
    label: "Serial Number",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "imei",
    label: "IMEI",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "orgGroup",
    label: "Organization Name",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "userName",
    label: "User Name",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "devicePool",
    label: "Device Pool",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "PhoneNumber",
    label: "Sim Phone No.",
    format: (value: any) => formatPhoneNumber(value || ""),
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "locationTrailEnabled",
    label: "Location Trail Enabled",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "lastCheckInTime",
    label: "Last Check-In",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "softwareVersion",
    label: "Software Version",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
];

export const DEVICE_LOOKUP_OPTIONS: DeviceColumnTypes[] = [
  {
    id: "serialNumber",
    label: "Serial Number",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "imei",
    label: "IMEI",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
];
